import Container from "../../components/Container";
import FullContent from "../../components/FullContent";
import HalfAndHalf from "../../components/HalfAndHalf";
import Heading from "../../components/Heading";
import TopSpace from "../../components/TopSpace";
import BannerShort from "../../components/banners/BannerShort";
import Service from "../../components/services/Service";
import AboutClient from "./AboutClient";
import {serviceObject} from '../../providers/GlobalObjects'
import useDocumentTitle from "../../hooks/useDocumentTitle";

const AboutUs = () => {
    useDocumentTitle('About Us')

    const des = `There are many variations of passages of Lorem Ipsum available, 
    but the majority have suffered alteration in some form, by injected humour, or 
    randomised words which don't look even slightly believable. If you are going to use a passage of 
    Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. 
    <br /><br />
    All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, 
    making this the first true generator on the Internet. 
    <br />
    It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate 
    Lorem Ipsum which looks reasonable. 
    <br />
    The generated Lorem Ipsum is therefore always free from repetition, 
    injected humour, or non-characteristic words etc. <ul class="mt-4">
    <li> List item 1</li> 
    <li> List item 1</li> 
    <li> List item 1</li> 
    <li> List item 1</li> 
</ul>`

    return (
        <TopSpace>
            <BannerShort 
                heading={'About Us'}
                description={'We provides talents to enterprise, government, mid-size and startups.'}
                bgImage={'/banner/review-banner2.jpg'}
            />

            <section className="py-5">
                <Container className="py-5">
                    <div className="row">
                        <div className="col-12">
                            <FullContent 
                                heading="Building software for world changers"
                                description={des}
                                buttonObject={''
                                    // {
                                    //     href:"#!",
                                    //     target:"_self",
                                    //     icon:<FaArrowRightLong className='ms-2' size={20}/>,
                                    //     iconPostion:"right",
                                    //     title:"Read More",
                                    // }
                                }
                            />
                        </div>
                    </div>

                    <HalfAndHalf 
                        className="py-5" 
                        heading="Building software for world changers"
                        description={des}
                        image={'https://placehold.co/1000x1000/jpg'}
                        flipped={0}
                        buttonObject={''}
                    />
                </Container>
            </section>


            <section className="section-12 bg-secondary-black py-5">
                <Container className="py-0 py-lg-5">
                    <div className="row">
                        <div className="col-12">
                            <Heading 
                                heading={'Meet Our Team'}
                            />
                        </div>
                    </div>

                    <AboutClient className="pt-5"/>
                </Container>
            </section>

            <Service 
                services={serviceObject}
            />
        </TopSpace>
    );
};

export default AboutUs;